// build/js/index.js
var BlurLrBlurSoftBlur = "blur(8px)";
var BorderRadiusLrBorderRadiusRadiusNone = "0px";
var BorderRadiusLrBorderRadiusRadius025 = "2px";
var BorderRadiusLrBorderRadiusRadius050 = "4px";
var BorderRadiusLrBorderRadiusRadius100 = "8px";
var BorderRadiusLrBorderRadiusRadius150 = "12px";
var BorderRadiusLrBorderRadiusRadius200 = "16px";
var BorderRadiusLrBorderRadiusRadiusFull = "9999px";
var BorderRadiusLrBorderRadiusRadius300 = "24px";
var BorderRadiusLrBorderRadiusRadiusMain = "4px";
var BorderWidthLrBorderWidthThin = "1px";
var BorderWidthLrBorderWidthMain = "1px";
var BorderWidthLrBorderWidthBold = "4px";
var BorderWidthLrBorderWidthSemiBold = "2px";
var BorderWidthLrBorderWidthActive = "2px";
var BorderWidthLrIconStrokeXs = "1px";
var BorderWidthLrIconStrokeSm = "1.5px";
var BorderWidthLrIconStrokeMd = "2px";
var BorderWidthLrIconStrokeLg = "3px";
var BorderWidthLrIconStrokeXl = "4px";
var ColorCoral50 = "#fff8f9";
var ColorCoral100 = "#ffe8eb";
var ColorCoral200 = "#ffc6cc";
var ColorCoral300 = "#ffa4ad";
var ColorCoral400 = "#ff7c89";
var ColorCoral500 = "#ff3f52";
var ColorCoral600 = "#d23443";
var ColorCoral700 = "#b12c39";
var ColorCoral800 = "#8f232e";
var ColorCoral900 = "#6a1a22";
var ColorCalmBlue50 = "#f9f9fe";
var ColorCalmBlue100 = "#ececfd";
var ColorCalmBlue200 = "#d1d1f9";
var ColorCalmBlue300 = "#b7b7f6";
var ColorCalmBlue400 = "#9c9cf3";
var ColorCalmBlue500 = "#7e7ef0";
var ColorCalmBlue600 = "#5e5eec";
var ColorCalmBlue700 = "#4646e9";
var ColorCalmBlue800 = "#0e0ee2";
var ColorCalmBlue900 = "#0c0cbc";
var ColorFlashPink50 = "#fff8fd";
var ColorFlashPink100 = "#ffe7f8";
var ColorFlashPink200 = "#ffc3ed";
var ColorFlashPink300 = "#ff9de1";
var ColorFlashPink400 = "#ff70d3";
var ColorFlashPink500 = "#ff3ec4";
var ColorFlashPink600 = "#c63099";
var ColorFlashPink700 = "#a82981";
var ColorFlashPink800 = "#872168";
var ColorFlashPink900 = "#65184d";
var ColorNeutral0 = "#ffffff";
var ColorNeutral50 = "#f7f6f4";
var ColorNeutral100 = "#ecebe9";
var ColorNeutral200 = "#e0dfdc";
var ColorNeutral300 = "#c9c8c6";
var ColorNeutral400 = "#bab9b6";
var ColorNeutral500 = "#959395";
var ColorNeutral600 = "#7a757a";
var ColorNeutral700 = "#5b565d";
var ColorNeutral800 = "#423a45";
var ColorNeutral900 = "#191b21";
var ColorInformation50 = "#f6fafe";
var ColorInformation100 = "#e2effd";
var ColorInformation200 = "#b6d8fa";
var ColorInformation300 = "#8bc2f7";
var ColorInformation400 = "#5eaaf4";
var ColorInformation500 = "#378ee4";
var ColorInformation600 = "#2d74b9";
var ColorInformation700 = "#26629c";
var ColorInformation800 = "#1f4e7d";
var ColorInformation900 = "#173a5d";
var ColorSuccess50 = "#f5fbf8";
var ColorSuccess100 = "#ddf3e9";
var ColorSuccess200 = "#abe0c8";
var ColorSuccess300 = "#79cea6";
var ColorSuccess400 = "#41b982";
var ColorSuccess500 = "#0f9f5c";
var ColorSuccess600 = "#0c824b";
var ColorSuccess700 = "#0a6e40";
var ColorSuccess800 = "#085833";
var ColorSuccess900 = "#064126";
var ColorWarning50 = "#fff9f6";
var ColorWarning100 = "#ffe9e0";
var ColorWarning200 = "#ffc9b1";
var ColorWarning300 = "#ffa881";
var ColorWarning400 = "#ff8149";
var ColorWarning500 = "#eb5e1f";
var ColorWarning600 = "#c04d1a";
var ColorWarning700 = "#a24116";
var ColorWarning800 = "#823411";
var ColorWarning900 = "#60270d";
var ColorError50 = "#fef9f9";
var ColorError100 = "#fceae9";
var ColorError200 = "#f6cac9";
var ColorError300 = "#f1abaa";
var ColorError400 = "#ec8987";
var ColorError500 = "#e55f5d";
var ColorError600 = "#d5312e";
var ColorError700 = "#b42927";
var ColorError800 = "#91211f";
var ColorError900 = "#560515";
var ColorDarkAlpha0 = "#191b2100";
var ColorDarkAlpha5 = "#191b210d";
var ColorDarkAlpha10 = "#191b211a";
var ColorDarkAlpha20 = "#191b2133";
var ColorDarkAlpha40 = "#191b2166";
var ColorDarkAlpha60 = "#191b2199";
var ColorDarkAlpha80 = "#191b21cc";
var ColorLightAlpha0 = "#ffffff00";
var ColorLightAlpha5 = "#ffffff0d";
var ColorLightAlpha10 = "#ffffff1a";
var ColorLightAlpha20 = "#ffffff33";
var ColorLightAlpha40 = "#ffffff66";
var ColorLightAlpha60 = "#ffffff99";
var ColorLightAlpha80 = "#ffffffcc";
var ColorLrColorBgEnergyA = "#009443";
var ColorLrColorBgEnergyB = "#4cb848";
var ColorLrColorBgEnergyC = "#9ecc00";
var ColorLrColorBgEnergyD = "#fff101";
var ColorLrColorBgEnergyE = "#ffc901";
var ColorLrColorBgEnergyF = "#fe741b";
var ColorLrColorBgEnergyG = "#d91627";
var ColorLrColorBgDurableGreat = "#009643";
var ColorLrColorBgDurableGood = "#fdc608";
var ColorLrColorBgDurableAverage = "#f07f00";
var ColorLrColorBgDurablePoor = "#c72a2f";
var ColorLrColorBgDurableBad = "#9f352d";
var ColorLrColorBgRepairGreat = "#009443";
var ColorLrColorBgRepairGood = "#9ecc00";
var ColorLrColorBgRepairAverage = "#ffc901";
var ColorLrColorBgRepairPoor = "#fe741b";
var ColorLrColorBgRepairBad = "#d91627";
var ColorLrColorBgMain = "#ffffff";
var ColorLrColorBgMainAlt = "#f7f6f4";
var ColorLrColorBgMainInverse = "#191b21";
var ColorLrColorBgHover = "#ecebe9";
var ColorLrColorBgPressed = "#e0dfdc";
var ColorLrColorBgDisabled = "#ecebe9";
var ColorLrColorBgBrandAccent = "#ff3f52";
var ColorLrColorBgSuccess = "#ddf3e9";
var ColorLrColorBgError = "#fceae9";
var ColorLrColorBgWarning = "#ffe9e0";
var ColorLrColorBgInfo = "#e2effd";
var ColorLrColorBgButtonPrimaryDefault = "#191b21";
var ColorLrColorBgButtonPrimaryDefaultInverse = "#ffffff";
var ColorLrColorBgButtonPrimaryHover = "#7a757a";
var ColorLrColorBgButtonPrimaryHoverInverse = "#ecebe9";
var ColorLrColorBgButtonPrimaryPressed = "#5b565d";
var ColorLrColorBgButtonPrimaryPressedInverse = "#e0dfdc";
var ColorLrColorBgButtonPrimaryDisabled = "#959395";
var ColorLrColorBgButtonPrimaryDisabledInverse = "#ecebe9";
var ColorLrColorBgButtonSecondaryDefault = "#ecebe9";
var ColorLrColorBgButtonSecondaryDefaultInverse = "#423a45";
var ColorLrColorBgButtonSecondaryHover = "#e0dfdc";
var ColorLrColorBgButtonSecondaryHoverInverse = "#7a757a";
var ColorLrColorBgButtonSecondaryPressed = "#c9c8c6";
var ColorLrColorBgButtonSecondaryPressedInverse = "#5b565d";
var ColorLrColorBgButtonSecondaryDisabled = "#ecebe9";
var ColorLrColorBgButtonSecondaryDisabledInverse = "#bab9b6";
var ColorLrColorBgButtonTertiaryDefault = "#ffffff";
var ColorLrColorBgButtonTertiaryDefaultInverse = "#191b2199";
var ColorLrColorBgButtonTertiaryHover = "#ecebe9";
var ColorLrColorBgButtonTertiaryHoverInverse = "#191b21cc";
var ColorLrColorBgButtonTertiaryPressed = "#e0dfdc";
var ColorLrColorBgButtonTertiaryPressedInverse = "#191b21";
var ColorLrColorBgButtonTertiaryDisabled = "#ecebe9";
var ColorLrColorBgButtonTertiaryDisabledInverse = "#191b2199";
var ColorLrColorBgButtonTertiarySelected = "#ecebe9";
var ColorLrColorBgButtonPlainHover = "#ecebe9";
var ColorLrColorBgButtonPlainHoverInverse = "#423a45";
var ColorLrColorBgButtonPlainPressed = "#e0dfdc";
var ColorLrColorBgButtonPlainPressedInverse = "#5b565d";
var ColorLrColorBgStrong = "#e0dfdc";
var ColorLrColorBgSuccessSubtle = "#f5fbf8";
var ColorLrColorBgErrorSubtle = "#fef9f9";
var ColorLrColorBgWarningSubtle = "#fff9f6";
var ColorLrColorBgInfoSubtle = "#f6fafe";
var ColorLrColorBgSuccessStrong = "#41b982";
var ColorLrColorBgErrorStrong = "#ec8987";
var ColorLrColorBgWarningStrong = "#ff8149";
var ColorLrColorBgInfoStrong = "#5eaaf4";
var ColorLrColorBgMainInverseAlt = "#423a45";
var ColorLrColorBgSuccessMedium = "#abe0c8";
var ColorLrColorBgErrorMedium = "#f6cac9";
var ColorLrColorBgWarningMedium = "#ffc9b1";
var ColorLrColorBgInfoMedium = "#b6d8fa";
var ColorLrColorBgActive = "#191b21";
var ColorLrColorBgScrim = "#191b2166";
var ColorLrColorBgButtonToggleActiveDefault = "#191b21";
var ColorLrColorBgButtonToggleActiveHover = "#7a757a";
var ColorLrColorBgButtonToggleActivePressed = "#5b565d";
var ColorLrColorBgButtonToggleActiveDisabled = "#959395";
var ColorLrColorBgButtonToggleInactiveDefault = "#ecebe9";
var ColorLrColorBgButtonToggleInactiveHover = "#e0dfdc";
var ColorLrColorBgButtonToggleInactivePressed = "#c9c8c6";
var ColorLrColorBgButtonToggleInactiveDisabled = "#ecebe9";
var ColorLrColorBgToggleSwitchHandleActiveDefault = "#ffffff";
var ColorLrColorBgToggleSwitchHandleActiveHover = "#ffffff";
var ColorLrColorBgToggleSwitchHandleActivePressed = "#ffffff";
var ColorLrColorBgToggleSwitchHandleActiveDisabled = "#ecebe9";
var ColorLrColorBgToggleSwitchHandleInactiveDefault = "#ffffff";
var ColorLrColorBgToggleSwitchHandleInactiveHover = "#ffffff";
var ColorLrColorBgToggleSwitchHandleInactivePressed = "#ffffff";
var ColorLrColorBgToggleSwitchHandleInactiveDisabled = "#ecebe9";
var ColorLrColorBgToggleSwitchTrackActiveDefault = "#191b21";
var ColorLrColorBgToggleSwitchTrackActiveHover = "#423a45";
var ColorLrColorBgToggleSwitchTrackActivePressed = "#5b565d";
var ColorLrColorBgToggleSwitchTrackActiveDisabled = "#c9c8c6";
var ColorLrColorBgToggleSwitchTrackInactiveDefault = "#c9c8c6";
var ColorLrColorBgToggleSwitchTrackInactiveHover = "#7a757a";
var ColorLrColorBgToggleSwitchTrackInactivePressed = "#959395";
var ColorLrColorBgToggleSwitchTrackInactiveDisabled = "#c9c8c6";
var ColorLrColorBgMedium = "#ecebe9";
var ColorLrColorBgHeavy = "#bab9b6";
var ColorLrColorBgActiveInverse = "#ffffff";
var ColorLrColorBgDiscountSubtle = "#fff8f9";
var ColorLrColorBgDiscount = "#ffe8eb";
var ColorLrColorBgDiscountStrong = "#d23443";
var ColorLrColorBgSkeleton = "#f7f6f4";
var ColorLrColorBgBlackFriday = "#191b21";
var ColorLrColorBgErrorHeavy = "#d5312e";
var ColorLrColorBgDivider = "#e0dfdc";
var ColorLrColorMajor = "#ff3f52";
var ColorLrColorMinor = "#ffffff";
var ColorLrColorTextMain = "#191b21";
var ColorLrColorTextMainInverse = "#ffffff";
var ColorLrColorTextBrandAccent = "#d23443";
var ColorLrColorTextSubtle = "#5b565d";
var ColorLrColorTextDisabled = "#959395";
var ColorLrColorTextDisabledInverse = "#f7f6f4";
var ColorLrColorTextSuccess = "#085833";
var ColorLrColorTextInfo = "#1f4e7d";
var ColorLrColorTextWarning = "#823411";
var ColorLrColorTextError = "#91211f";
var ColorLrColorTextLight = "#7a757a";
var ColorLrColorTextSubtleInverse = "#ecebe9";
var ColorLrColorTextHover = "#5b565d";
var ColorLrColorTextHoverInverse = "#e0dfdc";
var ColorLrColorTextVisited = "#a82981";
var ColorLrColorTextVisitedInverse = "#ffc3ed";
var ColorLrColorTextPressed = "#191b21";
var ColorLrColorTextPressedInverse = "#ffffff";
var ColorLrColorTextDiscount = "#d23443";
var ColorLrColorTextFrenchDay = "#4646e9";
var ColorLrColorBorderMain = "#959395";
var ColorLrColorBorderHover = "#7a757a";
var ColorLrColorBorderPressed = "#5b565d";
var ColorLrColorBorderActive = "#191b21";
var ColorLrColorBorderFocus = "#5eaaf4";
var ColorLrColorBorderError = "#e55f5d";
var ColorLrColorBorderErrorSubtle = "#f1abaa";
var ColorLrColorBorderSuccess = "#0f9f5c";
var ColorLrColorBorderSuccessSubtle = "#79cea6";
var ColorLrColorBorderInfo = "#378ee4";
var ColorLrColorBorderInfoSubtle = "#8bc2f7";
var ColorLrColorBorderWarning = "#eb5e1f";
var ColorLrColorBorderWarningSubtle = "#ffa881";
var ColorLrColorBorderDisabled = "#e0dfdc";
var ColorLrColorBorderSubtle = "#e0dfdc";
var ColorLrColorBorderLight = "#ecebe9";
var ColorLrColorBorderMainInverse = "#ffffff";
var ColorLrColorBorderMedium = "#959395";
var ColorLrColorBorderBrandAccent = "#ff3f52";
var ColorLrColorBorderStrong = "#191b21";
var ColorLrColorIconMain = "#191b21";
var ColorLrColorIconSubtle = "#5b565d";
var ColorLrColorIconMainInverse = "#ffffff";
var ColorLrColorIconSuccess = "#085833";
var ColorLrColorIconInfo = "#1f4e7d";
var ColorLrColorIconWarning = "#823411";
var ColorLrColorIconError = "#91211f";
var ColorLrColorIconDisabled = "#7a757a";
var ColorLrColorIconDisabledInverse = "#f7f6f4";
var ColorLrColorIconLight = "#7a757a";
var ColorLrColorIconBrandAccent = "#ff3f52";
var ColorLrColorIconHover = "#5b565d";
var ColorLrColorIconHoverInverse = "#e0dfdc";
var ColorLrColorIconVisited = "#a82981";
var ColorLrColorIconVisitedInverse = "#ffc3ed";
var ColorLrColorIconWishlist = "#ff3f52";
var ColorLrColorIconDiscount = "#d23443";
var ColorLrColorIconStarRating = "#423a45";
var ColorLrColorIconFrenchDay = "#4646e9";
var ColorLrColorIconDiscrete = "#959395";
var ColorLrplusColorMajor = "#0e0ee2";
var ColorLrplusColorMinor = "#ffffff";
var ColorLrplusColorBrandAccent = "#ff3ec4";
var ColorLrplusColorBgMajor = "#0e0ee2";
var ColorLrplusColorBgMinor = "#ffffff";
var ColorLrplusColorBgMajorLight = "#ececfd";
var ColorLrplusColorTextMajor = "#0e0ee2";
var ColorLrplusColorTextNeutral = "#191b21";
var ColorLrplusColorTextBrandAccent = "#ff3ec4";
var ColorLrplusColorTextMajorInverse = "#ffffff";
var ColorLrplusColorIconMajor = "#0e0ee2";
var ColorLrplusColorIconMinor = "#ff3ec4";
var ColorLrplusColorBorderMajor = "#0e0ee2";
var ColorLrplusColorBorderBrandAccent = "#ff3ec4";
var ColorLrplusToggleSwitchTrackActiveDefault = "#0e0ee2";
var ColorLrplusToggleSwitchTrackActiveHover = "#4646e9";
var ColorLrplusToggleSwitchTrackActivePressed = "#0c0cbc";
var ColorLrplusToggleSwitchTrackActiveDisabled = "#c9c8c6";
var ColorAmpmColorMajor = "#af3c19";
var ColorBrandRedoute = "#ff3f52";
var ColorBrandLaredouteplusPrimary = "#0e0ee2";
var ColorBrandLaredouteplusSecondary = "#ff3ec4";
var ColorBrandAmpmMajor = "#af3c19";
var ColorBrandAmpmInverse = "#fdfdfc";
var ColorBrandLrInterieurs = "#0d525a";
var ColorBrandLrCollections = "#890b58";
var ColorBrandGoForGood = "#922a7d";
var ColorBrandLarebouclePrimary = "#4d147c";
var ColorBrandLareboucleSecondary = "#ff64c6";
var ColorBrandLareboucleTertiary = "#944bff";
var ColorBrandWhite = "#ffffff";
var ColorBrandBlack = "#191b21";
var ColorPurple50 = "#f0e5ff";
var ColorPurple100 = "#e6d4ff";
var ColorPurple200 = "#d5b7ff";
var ColorPurple500 = "#ab6fff";
var ColorPurple600 = "#ab6fff";
var ColorPurple700 = "#8959cc";
var ColorPurple800 = "#57328c";
var ColorPurple900 = "#2a0960";
var ColorYellow50 = "#fffee9";
var ColorYellow100 = "#fffcc4";
var ColorYellow200 = "#fff980";
var ColorYellow500 = "#fff200";
var ColorCoralLaredoute100 = "#ffe4e5";
var ColorCoralLaredoute200 = "#ffc6cc";
var ColorCoralLaredoute300 = "#ffa4ad";
var ColorCoralLaredoute500 = "#ff3f52";
var ColorCoralLaredoute600 = "#d23443";
var ColorCoralLaredoute700 = "#b02835";
var ColorAquaMarine50 = "#effffa";
var ColorAquaMarine100 = "#dffff5";
var ColorAquaMarine200 = "#c9ffed";
var ColorAquaMarine300 = "#8fffda";
var ColorAquaMarine500 = "#03ffae";
var ColorAquaMarine700 = "#78d2b4";
var ColorAquaMarine900 = "#029b81";
var ColorFuschia50 = "#fcdeff";
var ColorFuschia100 = "#f9beff";
var ColorFuschia200 = "#f491ff";
var ColorFuschia500 = "#e101ff";
var ColorFuschia700 = "#b912d1";
var ColorFuschia900 = "#691445";
var ColorPeach50 = "#fff5f2";
var ColorPeach100 = "#ffe6de";
var ColorPeach200 = "#ffd4c8";
var ColorPeach500 = "#ffaa90";
var ColorPeach700 = "#d28e79";
var ColorBlue50 = "#f0f2ff";
var ColorBlue100 = "#e8ecff";
var ColorBlue200 = "#dadfff";
var ColorBlue300 = "#b4beff";
var ColorBlue700 = "#959ed2";
var ColorBlue900 = "#1a194a";
var ColorSky50 = "#f2faff";
var ColorSky100 = "#def2ff";
var ColorSky200 = "#cdebff";
var ColorSky300 = "#9dd4fa";
var ColorSky700 = "#182d9a";
var ColorTurquoise50 = "#f0ffff";
var ColorTurquoise75 = "#e5fcfc";
var ColorTurquoise100 = "#daffff";
var ColorTurquoise200 = "#c0ffff";
var ColorTurquoise500 = "#75ffff";
var ColorTurquoise700 = "#64d3d1";
var ColorWater50 = "#e6f8f8";
var ColorWater100 = "#cdf2f2";
var ColorWater200 = "#abe9e9";
var ColorWater300 = "#40adae";
var ColorWater700 = "#004a70";
var ColorWater900 = "#0f3d56";
var ColorPink50 = "#ffeeff";
var ColorPink100 = "#ffe6ff";
var ColorPink200 = "#ffd4ff";
var ColorPink300 = "#ffaaff";
var ColorPink500 = "#ff3ec4";
var ColorPink700 = "#d28ed2";
var ColorGreen50 = "#f6ffea";
var ColorGreen100 = "#ebf9d7";
var ColorGreen200 = "#b6ddbb";
var ColorGreen500 = "#769e65";
var ColorGreen700 = "#356052";
var ColorGreen900 = "#2e4c41";
var ColorLime50 = "#fafeea";
var ColorLime100 = "#f5fed6";
var ColorLime200 = "#eefeba";
var ColorLime500 = "#ddfe6e";
var ColorLime700 = "#b6d15e";
var ColorBrown50 = "#fff9ef";
var ColorBrown100 = "#fff3e0";
var ColorBrown200 = "#ffebcc";
var ColorBrown500 = "#d4b890";
var ColorBrown700 = "#4f2e0d";
var ColorBrown900 = "#4a0e0e";
var ColorColorOrange = "#fd5801";
var DimensionLrFocusInsetOffset = "-1px";
var DimensionLrFocusInsetWidth = "4px";
var DimensionLrFocusOutlineOffset = "2px";
var DimensionLrFocusOutlineWidth = "4px";
var DimensionLrSpacingTogglePillGroup = "-4px";
var FontFamilyLrFontFamilyDefault = "Poppins";
var FontSizeLrFontSize125 = "10px";
var FontSizeLrFontSize150 = "12px";
var FontSizeLrFontSize175 = "14px";
var FontSizeLrFontSize200 = "16px";
var FontSizeLrFontSize250 = "20px";
var FontSizeLrFontSize300 = "24px";
var FontSizeLrFontSize350 = "28px";
var FontSizeLrFontSize400 = "32px";
var FontSizeLrFontSize500 = "40px";
var FontSizeLrFontSize600 = "48px";
var FontSizeLrFontSize725 = "58px";
var FontSizeLrFontSize875 = "70px";
var FontWeightLrFontWeightLight = "300";
var FontWeightLrFontWeightRegular = "400";
var FontWeightLrFontWeightMedium = "500";
var FontWeightLrFontWeightSemiBold = "600";
var GradientLrGradientOnboarding = "linear-gradient(63.48080377872849deg, #484fed 0%, #10a761 100%)";
var GradientLrGradientOnboardingAlpha = "linear-gradient(63.48080377872849deg, #10a76133 0%, #484fed33 100%)";
var GradientLrGradientGold = "linear-gradient(-142.98370655772473deg, #f4efbd 0%, #ece6a7 41.63%, #fbf7cd 61.42%, #b08634 100%)";
var GradientLrGradientSilver = "linear-gradient(-142.98370655772473deg, #f1f1f1 0%, #f6f6f6 41.63%, #ffffff 61.42%, #c6c6c6 100%)";
var GradientLrGradientTransparency = "linear-gradient(-142.98370655772473deg, #ddf9fd 0%, #f6fefe 41.63%, #ffffff 61.42%, #c3eaef 100%)";
var GradientLrGradientPurple = "linear-gradient(-135deg, #8500e3 0%, #e5009f 100%)";
var GradientLrplusColorBorderGradientAccent = "linear-gradient(45.08581488268087deg, rgba(#ff3ec4, 1) 0%, rgba(#ff3ec4, 1) 5%, rgba(#0e0ee2, 1) 5%, rgba(#0e0ee2, 1) 30%, rgba(#ff3ec4, 1) 30%, rgba(#ff3ec4, 1) 70%, rgba(#0e0ee2, 1) 70%)";
var LineHeightLrFontLineHeight150 = "12px";
var LineHeightLrFontLineHeight200 = "16px";
var LineHeightLrFontLineHeight225 = "18px";
var LineHeightLrFontLineHeight250 = "20px";
var LineHeightLrFontLineHeight275 = "22px";
var LineHeightLrFontLineHeight300 = "24px";
var LineHeightLrFontLineHeight325 = "26px";
var LineHeightLrFontLineHeight375 = "30px";
var LineHeightLrFontLineHeight450 = "36px";
var LineHeightLrFontLineHeight500 = "40px";
var LineHeightLrFontLineHeight625 = "50px";
var LineHeightLrFontLineHeight750 = "60px";
var LineHeightLrFontLineHeight900 = "72px";
var LineHeightLrFontLineHeight1100 = "88px";
var ProductCopyTextLamailleVersion = "0.33.0";
var ShadowLrElevationSubtle = "0px 2px 4px 0px rgba(#191b210d, 0.05), 0px 2px 8px 0px rgba(#191b211a, 0.1)";
var ShadowLrElevationMedium = "0px 0px 2px 0px rgba(#191b211a, 0.1), 0px 4px 8px 0px rgba(#191b211a, 0.1), 0px 16px 32px 0px rgba(#191b211a, 0.1)";
var ShadowLrElevationStrong = "0px 2px 4px 0px rgba(#191b211a, 0.1), 0px 4px 8px 0px rgba(#191b211a, 0.1), 0px 8px 16px 0px rgba(#191b211a, 0.1), 0px 16px 32px 0px rgba(#191b211a, 0.1)";
var ShadowLrElevationRaisedBottom = "0px -2px 4px 0px rgba(#191b210d, 0.05), 0px -2px 8px 0px rgba(#191b210d, 0.05)";
var ShadowLrElevationRaisedTop = "0px 2px 4px 0px rgba(#191b210d, 0.05), 0px 2px 8px 0px rgba(#191b211a, 0.1)";
var SizeLrSizeSize0 = "0px";
var SizeLrSizeSize025 = "2px";
var SizeLrSizeSize050 = "4px";
var SizeLrSizeSize100 = "8px";
var SizeLrSizeSize150 = "12px";
var SizeLrSizeSize200 = "16px";
var SizeLrSizeSize250 = "20px";
var SizeLrSizeSize300 = "24px";
var SizeLrSizeSize400 = "32px";
var SizeLrSizeSize500 = "40px";
var SizeLrSizeSize550 = "44px";
var SizeLrSizeSize600 = "48px";
var SizeLrSizeSize700 = "56px";
var SizeLrSizeSize800 = "64px";
var SizeLrSizeSize900 = "72px";
var SizeLrSizeSize1000 = "80px";
var SizeLrSizeSize450 = "36px";
var SizeLrSizeSize075 = "6px";
var SizeLrSizeSize1100 = "88px";
var SizeLrSizeWebMaxWidth = "1920px";
var SizeLrSizePopoverMinHeight = "296px";
var SizeLrSizePopoverMinWidth = "296px";
var SizeLrSizePopoverMaxHeight = "400px";
var SizeLrSizePopoverMaxWidth = "400px";
var SizeLrSizeDividerSm = "1px";
var SizeLrSizeDividerMd = "4px";
var SizeLrSizeSize1200 = "96px";
var SizeLrSizeFormInputMinWidthSm = "296px";
var SizeLrSizeFormInputMinWidthMd = "320px";
var SizeLrBreakpointMd = "768px";
var SizeLrBreakpointXl = "1920px";
var SizeLrBreakpointSm = "390px";
var SizeLrBreakpointLg = "1280px";
var SpaceLrSpacingSpacing0 = "0px";
var SpaceLrSpacingSpacing025 = "2px";
var SpaceLrSpacingSpacing050 = "4px";
var SpaceLrSpacingSpacing075 = "6px";
var SpaceLrSpacingSpacing100 = "8px";
var SpaceLrSpacingSpacing125 = "10px";
var SpaceLrSpacingSpacing150 = "12px";
var SpaceLrSpacingSpacing200 = "16px";
var SpaceLrSpacingSpacing225 = "18px";
var SpaceLrSpacingSpacing250 = "20px";
var SpaceLrSpacingSpacing300 = "24px";
var SpaceLrSpacingSpacing400 = "32px";
var SpaceLrSpacingSpacing500 = "40px";
var SpaceLrSpacingSpacing550 = "44px";
var SpaceLrSpacingSpacing600 = "48px";
var SpaceLrSpacingSpacing700 = "56px";
var SpaceLrSpacingSpacing800 = "64px";
var SpaceLrSpacingSpacing900 = "72px";
var SpaceLrSpacingSpacing1000 = "80px";
var SpaceLrSpacingSpacingActionTertiarySm = "9px";
var SpaceLrSpacingSpacingActionIconTertiarySm = "7px";
var SpaceLrSpacingSpacingActionTertiaryMd = "11px";
var SpaceLrSpacingSpacingActionIconTertiaryMd = "11px";
var SpaceLrSpacingSpacing1100 = "88px";
var StringLrFontCase = "uppercase";
var TypographyLegacyTitleXlDefault = "600 30px/40px Poppins";
var TypographyLegacyTitleXlDeviceMob = "600 30px/40px Poppins";
var TypographyLegacyTitleXlDeviceTab = "600 45px/60px Poppins";
var TypographyLegacyTitleXlDeviceDesk = "600 61px/68px Poppins";
var TypographyLegacyTitleLgDeviceMob = "600 26px/36px Poppins";
var TypographyLegacyTitleLgDeviceTab = "600 38px/52px Poppins";
var TypographyLegacyTitleLgDeviceDesk = "600 49px/56px Poppins";
var TypographyLegacyTitleLgDefault = "600 26px/36px Poppins";
var TypographyLegacyTitleMdDeviceMob = "600 23px/32px Poppins";
var TypographyLegacyTitleMdDeviceTab = "600 30px/40px Poppins";
var TypographyLegacyTitleMdDeviceDesk = "600 39px/48px Poppins";
var TypographyLegacyTitleMdDefault = "600 23px/32px Poppins";
var TypographyLegacyTitleSmDeviceMob = "600 20px/28px Poppins";
var TypographyLegacyTitleSmDeviceTab = "600 26px/36px Poppins";
var TypographyLegacyTitleSmDeviceDesk = "600 31px/40px Poppins";
var TypographyLegacyTitleSmDefault = "600 20px/28px Poppins";
var TypographyLegacyTitleXsDeviceMob = "600 18px/24px Poppins";
var TypographyLegacyTitleXsDeviceTab = "600 22px/32px Poppins";
var TypographyLegacyTitleXsDeviceDesk = "600 25px/36px Poppins";
var TypographyLegacyTitleXsDefault = "600 18px/24px Poppins";
var TypographyLegacyTitleXxsDeviceMob = "600 16px/20px Poppins";
var TypographyLegacyTitleXxsDeviceTab = "600 18px/27px Poppins";
var TypographyLegacyTitleXxsDeviceDesk = "600 20px/30px Poppins";
var TypographyLegacyTitleXxsDefault = "600 16px/20px Poppins";
var TypographyLegacyBodyLgReg = "400 16px/24px Poppins";
var TypographyLegacyBodyLgSemi = "600 16px/24px Poppins";
var TypographyLegacyBodyLgRegUpper = "400 16px/24px Poppins";
var TypographyLegacyBodyLgSemiUnder = "600 16px/24px Poppins";
var TypographyLegacyBodyLgSemiUpper = "600 16px/24px Poppins";
var TypographyLegacyBodyLgRegUnder = "400 16px/24px Poppins";
var TypographyLegacyBodyMdReg = "400 14px/20px Poppins";
var TypographyLegacyBodyMdSemi = "600 14px/20px Poppins";
var TypographyLegacyBodyMdSemiUpperMob = "600 14px/20px Poppins";
var TypographyLegacyBodyMdSemiUpperTab = "600 15px/20px Poppins";
var TypographyLegacyBodyMdSemiUpperDesk = "600 16px/24px Poppins";
var TypographyLegacyBodyMdSemiUnder = "600 14px/20px Poppins";
var TypographyLegacyBodyMdItalic = "400 14px/20px Poppins";
var TypographyLegacyBodyMdRegUpper = "400 14px/20px Poppins";
var TypographyLegacyBodyMdRegUnder = "400 14px/20px Poppins";
var TypographyLegacyBodySmReg = "400 12px/16px Poppins";
var TypographyLegacyBodySmSemi = "600 12px/16px Poppins";
var TypographyLegacyBodySmSemiUnder = "600 12px/16px Poppins";
var TypographyLegacyBodySmSemiUpper = "600 12px/16px Poppins";
var TypographyLegacyBodySmRegStriked = "400 12px/16px Poppins";
var TypographyLegacyBodySmRegUnder = "400 12px/16px Poppins";
var TypographyLegacyBodyXsSemi = "600 10px/12px Poppins";
var TypographyLegacyBodyXsReg = "400 10px/12px Poppins";
var TypographyLrFontDisplayEnormousMediumDesk = "500 70px/88px Poppins";
var TypographyLrFontDisplayEnormousMediumMob = "500 58px/72px Poppins";
var TypographyLrFontDisplayEnormousLightDesk = "300 70px/88px Poppins";
var TypographyLrFontDisplayEnormousLightMob = "300 58px/72px Poppins";
var TypographyLrFontDisplayMassiveMediumDesk = "500 58px/72px Poppins";
var TypographyLrFontDisplayMassiveMediumMob = "500 48px/72px Poppins";
var TypographyLrFontDisplayMassiveLightDesk = "300 58px/60px Poppins";
var TypographyLrFontDisplayMassiveLightMob = "300 48px/60px Poppins";
var TypographyLrFontDisplayOversizeMediumDesk = "500 48px/60px Poppins";
var TypographyLrFontDisplayOversizeMediumMob = "500 40px/50px Poppins";
var TypographyLrFontDisplayOversizeLightDesk = "300 48px/60px Poppins";
var TypographyLrFontDisplayOversizeLightMob = "300 40px/50px Poppins";
var TypographyLrFontTitleHugeMediumDesk = "500 40px/50px Poppins";
var TypographyLrFontTitleHugeMediumMob = "500 32px/40px Poppins";
var TypographyLrFontTitleHugeLightDesk = "300 40px/50px Poppins";
var TypographyLrFontTitleHugeLightMob = "300 32px/40px Poppins";
var TypographyLrFontTitleGiantMediumDesk = "500 32px/40px Poppins";
var TypographyLrFontTitleGiantMediumMob = "500 28px/36px Poppins";
var TypographyLrFontTitleGiantLightDesk = "300 32px/40px Poppins";
var TypographyLrFontTitleGiantLightMob = "300 28px/36px Poppins";
var TypographyLrFontTitleBigMediumDesk = "500 28px/36px Poppins";
var TypographyLrFontTitleBigMediumMob = "500 24px/30px Poppins";
var TypographyLrFontTitleBigLightDesk = "300 28px/36px Poppins";
var TypographyLrFontTitleBigLightMob = "300 24px/30px Poppins";
var TypographyLrFontSubtitleExtraLargeMediumDesk = "500 24px/30px Poppins";
var TypographyLrFontSubtitleExtraLargeMediumMob = "500 20px/26px Poppins";
var TypographyLrFontSubtitleExtraLargeLightDesk = "300 24px/30px Poppins";
var TypographyLrFontSubtitleExtraLargeLightMob = "300 20px/26px Poppins";
var TypographyLrFontSubtitleLargeMediumDesk = "500 20px/26px Poppins";
var TypographyLrFontSubtitleLargeMediumMob = "500 16px/20px Poppins";
var TypographyLrFontSubtitleLargeLightDesk = "300 20px/26px Poppins";
var TypographyLrFontSubtitleLargeLightMob = "300 16px/20px Poppins";
var TypographyLrFontSubtitleCompactMedium = "500 16px/20px Poppins";
var TypographyLrFontSubtitleCompactLight = "300 16px/20px Poppins";
var TypographyLrFontSubtitleTightMedium = "500 14px/18px Poppins";
var TypographyLrFontSubtitleTightLight = "300 14px/18px Poppins";
var TypographyLrFontBodyStandardLight = "300 16px/24px Poppins";
var TypographyLrFontBodyStandardMedium = "500 16px/24px Poppins";
var TypographyLrFontBodyBalancedLight = "300 14px/22px Poppins";
var TypographyLrFontBodyBalancedMedium = "500 14px/22px Poppins";
var TypographyLrFontBodySmallMedium = "500 12px/18px Poppins";
var TypographyLrFontBodySmallLight = "300 12px/18px Poppins";
var TypographyLrFontBodyTinyMedium = "500 10px/16px Poppins";
var TypographyLrFontBodyTinyLight = "300 10px/16px Poppins";
var TypographyLrFontButtonMd = "600 16px/24px Poppins";
var TypographyLrFontButtonSm = "600 14px/20px Poppins";
var TypographyLrFontLinkXs = "600 10px/12px Poppins";
var TypographyLrFontLinkSm = "600 12px/16px Poppins";
var TypographyLrFontLinkMd = "600 14px/20px Poppins";
var TypographyLrFontLinkLg = "600 16px/24px Poppins";
var TypographyLrFontDiscountPercentageSm = "600 12px/18px Poppins";
var TypographyLrFontDiscountPercentageMd = "600 14px/22px Poppins";
var TypographyLrFontDiscountPercentageXs = "600 10px/16px Poppins";
export {
  BlurLrBlurSoftBlur,
  BorderRadiusLrBorderRadiusRadius025,
  BorderRadiusLrBorderRadiusRadius050,
  BorderRadiusLrBorderRadiusRadius100,
  BorderRadiusLrBorderRadiusRadius150,
  BorderRadiusLrBorderRadiusRadius200,
  BorderRadiusLrBorderRadiusRadius300,
  BorderRadiusLrBorderRadiusRadiusFull,
  BorderRadiusLrBorderRadiusRadiusMain,
  BorderRadiusLrBorderRadiusRadiusNone,
  BorderWidthLrBorderWidthActive,
  BorderWidthLrBorderWidthBold,
  BorderWidthLrBorderWidthMain,
  BorderWidthLrBorderWidthSemiBold,
  BorderWidthLrBorderWidthThin,
  BorderWidthLrIconStrokeLg,
  BorderWidthLrIconStrokeMd,
  BorderWidthLrIconStrokeSm,
  BorderWidthLrIconStrokeXl,
  BorderWidthLrIconStrokeXs,
  ColorAmpmColorMajor,
  ColorAquaMarine100,
  ColorAquaMarine200,
  ColorAquaMarine300,
  ColorAquaMarine50,
  ColorAquaMarine500,
  ColorAquaMarine700,
  ColorAquaMarine900,
  ColorBlue100,
  ColorBlue200,
  ColorBlue300,
  ColorBlue50,
  ColorBlue700,
  ColorBlue900,
  ColorBrandAmpmInverse,
  ColorBrandAmpmMajor,
  ColorBrandBlack,
  ColorBrandGoForGood,
  ColorBrandLarebouclePrimary,
  ColorBrandLareboucleSecondary,
  ColorBrandLareboucleTertiary,
  ColorBrandLaredouteplusPrimary,
  ColorBrandLaredouteplusSecondary,
  ColorBrandLrCollections,
  ColorBrandLrInterieurs,
  ColorBrandRedoute,
  ColorBrandWhite,
  ColorBrown100,
  ColorBrown200,
  ColorBrown50,
  ColorBrown500,
  ColorBrown700,
  ColorBrown900,
  ColorCalmBlue100,
  ColorCalmBlue200,
  ColorCalmBlue300,
  ColorCalmBlue400,
  ColorCalmBlue50,
  ColorCalmBlue500,
  ColorCalmBlue600,
  ColorCalmBlue700,
  ColorCalmBlue800,
  ColorCalmBlue900,
  ColorColorOrange,
  ColorCoral100,
  ColorCoral200,
  ColorCoral300,
  ColorCoral400,
  ColorCoral50,
  ColorCoral500,
  ColorCoral600,
  ColorCoral700,
  ColorCoral800,
  ColorCoral900,
  ColorCoralLaredoute100,
  ColorCoralLaredoute200,
  ColorCoralLaredoute300,
  ColorCoralLaredoute500,
  ColorCoralLaredoute600,
  ColorCoralLaredoute700,
  ColorDarkAlpha0,
  ColorDarkAlpha10,
  ColorDarkAlpha20,
  ColorDarkAlpha40,
  ColorDarkAlpha5,
  ColorDarkAlpha60,
  ColorDarkAlpha80,
  ColorError100,
  ColorError200,
  ColorError300,
  ColorError400,
  ColorError50,
  ColorError500,
  ColorError600,
  ColorError700,
  ColorError800,
  ColorError900,
  ColorFlashPink100,
  ColorFlashPink200,
  ColorFlashPink300,
  ColorFlashPink400,
  ColorFlashPink50,
  ColorFlashPink500,
  ColorFlashPink600,
  ColorFlashPink700,
  ColorFlashPink800,
  ColorFlashPink900,
  ColorFuschia100,
  ColorFuschia200,
  ColorFuschia50,
  ColorFuschia500,
  ColorFuschia700,
  ColorFuschia900,
  ColorGreen100,
  ColorGreen200,
  ColorGreen50,
  ColorGreen500,
  ColorGreen700,
  ColorGreen900,
  ColorInformation100,
  ColorInformation200,
  ColorInformation300,
  ColorInformation400,
  ColorInformation50,
  ColorInformation500,
  ColorInformation600,
  ColorInformation700,
  ColorInformation800,
  ColorInformation900,
  ColorLightAlpha0,
  ColorLightAlpha10,
  ColorLightAlpha20,
  ColorLightAlpha40,
  ColorLightAlpha5,
  ColorLightAlpha60,
  ColorLightAlpha80,
  ColorLime100,
  ColorLime200,
  ColorLime50,
  ColorLime500,
  ColorLime700,
  ColorLrColorBgActive,
  ColorLrColorBgActiveInverse,
  ColorLrColorBgBlackFriday,
  ColorLrColorBgBrandAccent,
  ColorLrColorBgButtonPlainHover,
  ColorLrColorBgButtonPlainHoverInverse,
  ColorLrColorBgButtonPlainPressed,
  ColorLrColorBgButtonPlainPressedInverse,
  ColorLrColorBgButtonPrimaryDefault,
  ColorLrColorBgButtonPrimaryDefaultInverse,
  ColorLrColorBgButtonPrimaryDisabled,
  ColorLrColorBgButtonPrimaryDisabledInverse,
  ColorLrColorBgButtonPrimaryHover,
  ColorLrColorBgButtonPrimaryHoverInverse,
  ColorLrColorBgButtonPrimaryPressed,
  ColorLrColorBgButtonPrimaryPressedInverse,
  ColorLrColorBgButtonSecondaryDefault,
  ColorLrColorBgButtonSecondaryDefaultInverse,
  ColorLrColorBgButtonSecondaryDisabled,
  ColorLrColorBgButtonSecondaryDisabledInverse,
  ColorLrColorBgButtonSecondaryHover,
  ColorLrColorBgButtonSecondaryHoverInverse,
  ColorLrColorBgButtonSecondaryPressed,
  ColorLrColorBgButtonSecondaryPressedInverse,
  ColorLrColorBgButtonTertiaryDefault,
  ColorLrColorBgButtonTertiaryDefaultInverse,
  ColorLrColorBgButtonTertiaryDisabled,
  ColorLrColorBgButtonTertiaryDisabledInverse,
  ColorLrColorBgButtonTertiaryHover,
  ColorLrColorBgButtonTertiaryHoverInverse,
  ColorLrColorBgButtonTertiaryPressed,
  ColorLrColorBgButtonTertiaryPressedInverse,
  ColorLrColorBgButtonTertiarySelected,
  ColorLrColorBgButtonToggleActiveDefault,
  ColorLrColorBgButtonToggleActiveDisabled,
  ColorLrColorBgButtonToggleActiveHover,
  ColorLrColorBgButtonToggleActivePressed,
  ColorLrColorBgButtonToggleInactiveDefault,
  ColorLrColorBgButtonToggleInactiveDisabled,
  ColorLrColorBgButtonToggleInactiveHover,
  ColorLrColorBgButtonToggleInactivePressed,
  ColorLrColorBgDisabled,
  ColorLrColorBgDiscount,
  ColorLrColorBgDiscountStrong,
  ColorLrColorBgDiscountSubtle,
  ColorLrColorBgDivider,
  ColorLrColorBgDurableAverage,
  ColorLrColorBgDurableBad,
  ColorLrColorBgDurableGood,
  ColorLrColorBgDurableGreat,
  ColorLrColorBgDurablePoor,
  ColorLrColorBgEnergyA,
  ColorLrColorBgEnergyB,
  ColorLrColorBgEnergyC,
  ColorLrColorBgEnergyD,
  ColorLrColorBgEnergyE,
  ColorLrColorBgEnergyF,
  ColorLrColorBgEnergyG,
  ColorLrColorBgError,
  ColorLrColorBgErrorHeavy,
  ColorLrColorBgErrorMedium,
  ColorLrColorBgErrorStrong,
  ColorLrColorBgErrorSubtle,
  ColorLrColorBgHeavy,
  ColorLrColorBgHover,
  ColorLrColorBgInfo,
  ColorLrColorBgInfoMedium,
  ColorLrColorBgInfoStrong,
  ColorLrColorBgInfoSubtle,
  ColorLrColorBgMain,
  ColorLrColorBgMainAlt,
  ColorLrColorBgMainInverse,
  ColorLrColorBgMainInverseAlt,
  ColorLrColorBgMedium,
  ColorLrColorBgPressed,
  ColorLrColorBgRepairAverage,
  ColorLrColorBgRepairBad,
  ColorLrColorBgRepairGood,
  ColorLrColorBgRepairGreat,
  ColorLrColorBgRepairPoor,
  ColorLrColorBgScrim,
  ColorLrColorBgSkeleton,
  ColorLrColorBgStrong,
  ColorLrColorBgSuccess,
  ColorLrColorBgSuccessMedium,
  ColorLrColorBgSuccessStrong,
  ColorLrColorBgSuccessSubtle,
  ColorLrColorBgToggleSwitchHandleActiveDefault,
  ColorLrColorBgToggleSwitchHandleActiveDisabled,
  ColorLrColorBgToggleSwitchHandleActiveHover,
  ColorLrColorBgToggleSwitchHandleActivePressed,
  ColorLrColorBgToggleSwitchHandleInactiveDefault,
  ColorLrColorBgToggleSwitchHandleInactiveDisabled,
  ColorLrColorBgToggleSwitchHandleInactiveHover,
  ColorLrColorBgToggleSwitchHandleInactivePressed,
  ColorLrColorBgToggleSwitchTrackActiveDefault,
  ColorLrColorBgToggleSwitchTrackActiveDisabled,
  ColorLrColorBgToggleSwitchTrackActiveHover,
  ColorLrColorBgToggleSwitchTrackActivePressed,
  ColorLrColorBgToggleSwitchTrackInactiveDefault,
  ColorLrColorBgToggleSwitchTrackInactiveDisabled,
  ColorLrColorBgToggleSwitchTrackInactiveHover,
  ColorLrColorBgToggleSwitchTrackInactivePressed,
  ColorLrColorBgWarning,
  ColorLrColorBgWarningMedium,
  ColorLrColorBgWarningStrong,
  ColorLrColorBgWarningSubtle,
  ColorLrColorBorderActive,
  ColorLrColorBorderBrandAccent,
  ColorLrColorBorderDisabled,
  ColorLrColorBorderError,
  ColorLrColorBorderErrorSubtle,
  ColorLrColorBorderFocus,
  ColorLrColorBorderHover,
  ColorLrColorBorderInfo,
  ColorLrColorBorderInfoSubtle,
  ColorLrColorBorderLight,
  ColorLrColorBorderMain,
  ColorLrColorBorderMainInverse,
  ColorLrColorBorderMedium,
  ColorLrColorBorderPressed,
  ColorLrColorBorderStrong,
  ColorLrColorBorderSubtle,
  ColorLrColorBorderSuccess,
  ColorLrColorBorderSuccessSubtle,
  ColorLrColorBorderWarning,
  ColorLrColorBorderWarningSubtle,
  ColorLrColorIconBrandAccent,
  ColorLrColorIconDisabled,
  ColorLrColorIconDisabledInverse,
  ColorLrColorIconDiscount,
  ColorLrColorIconDiscrete,
  ColorLrColorIconError,
  ColorLrColorIconFrenchDay,
  ColorLrColorIconHover,
  ColorLrColorIconHoverInverse,
  ColorLrColorIconInfo,
  ColorLrColorIconLight,
  ColorLrColorIconMain,
  ColorLrColorIconMainInverse,
  ColorLrColorIconStarRating,
  ColorLrColorIconSubtle,
  ColorLrColorIconSuccess,
  ColorLrColorIconVisited,
  ColorLrColorIconVisitedInverse,
  ColorLrColorIconWarning,
  ColorLrColorIconWishlist,
  ColorLrColorMajor,
  ColorLrColorMinor,
  ColorLrColorTextBrandAccent,
  ColorLrColorTextDisabled,
  ColorLrColorTextDisabledInverse,
  ColorLrColorTextDiscount,
  ColorLrColorTextError,
  ColorLrColorTextFrenchDay,
  ColorLrColorTextHover,
  ColorLrColorTextHoverInverse,
  ColorLrColorTextInfo,
  ColorLrColorTextLight,
  ColorLrColorTextMain,
  ColorLrColorTextMainInverse,
  ColorLrColorTextPressed,
  ColorLrColorTextPressedInverse,
  ColorLrColorTextSubtle,
  ColorLrColorTextSubtleInverse,
  ColorLrColorTextSuccess,
  ColorLrColorTextVisited,
  ColorLrColorTextVisitedInverse,
  ColorLrColorTextWarning,
  ColorLrplusColorBgMajor,
  ColorLrplusColorBgMajorLight,
  ColorLrplusColorBgMinor,
  ColorLrplusColorBorderBrandAccent,
  ColorLrplusColorBorderMajor,
  ColorLrplusColorBrandAccent,
  ColorLrplusColorIconMajor,
  ColorLrplusColorIconMinor,
  ColorLrplusColorMajor,
  ColorLrplusColorMinor,
  ColorLrplusColorTextBrandAccent,
  ColorLrplusColorTextMajor,
  ColorLrplusColorTextMajorInverse,
  ColorLrplusColorTextNeutral,
  ColorLrplusToggleSwitchTrackActiveDefault,
  ColorLrplusToggleSwitchTrackActiveDisabled,
  ColorLrplusToggleSwitchTrackActiveHover,
  ColorLrplusToggleSwitchTrackActivePressed,
  ColorNeutral0,
  ColorNeutral100,
  ColorNeutral200,
  ColorNeutral300,
  ColorNeutral400,
  ColorNeutral50,
  ColorNeutral500,
  ColorNeutral600,
  ColorNeutral700,
  ColorNeutral800,
  ColorNeutral900,
  ColorPeach100,
  ColorPeach200,
  ColorPeach50,
  ColorPeach500,
  ColorPeach700,
  ColorPink100,
  ColorPink200,
  ColorPink300,
  ColorPink50,
  ColorPink500,
  ColorPink700,
  ColorPurple100,
  ColorPurple200,
  ColorPurple50,
  ColorPurple500,
  ColorPurple600,
  ColorPurple700,
  ColorPurple800,
  ColorPurple900,
  ColorSky100,
  ColorSky200,
  ColorSky300,
  ColorSky50,
  ColorSky700,
  ColorSuccess100,
  ColorSuccess200,
  ColorSuccess300,
  ColorSuccess400,
  ColorSuccess50,
  ColorSuccess500,
  ColorSuccess600,
  ColorSuccess700,
  ColorSuccess800,
  ColorSuccess900,
  ColorTurquoise100,
  ColorTurquoise200,
  ColorTurquoise50,
  ColorTurquoise500,
  ColorTurquoise700,
  ColorTurquoise75,
  ColorWarning100,
  ColorWarning200,
  ColorWarning300,
  ColorWarning400,
  ColorWarning50,
  ColorWarning500,
  ColorWarning600,
  ColorWarning700,
  ColorWarning800,
  ColorWarning900,
  ColorWater100,
  ColorWater200,
  ColorWater300,
  ColorWater50,
  ColorWater700,
  ColorWater900,
  ColorYellow100,
  ColorYellow200,
  ColorYellow50,
  ColorYellow500,
  DimensionLrFocusInsetOffset,
  DimensionLrFocusInsetWidth,
  DimensionLrFocusOutlineOffset,
  DimensionLrFocusOutlineWidth,
  DimensionLrSpacingTogglePillGroup,
  FontFamilyLrFontFamilyDefault,
  FontSizeLrFontSize125,
  FontSizeLrFontSize150,
  FontSizeLrFontSize175,
  FontSizeLrFontSize200,
  FontSizeLrFontSize250,
  FontSizeLrFontSize300,
  FontSizeLrFontSize350,
  FontSizeLrFontSize400,
  FontSizeLrFontSize500,
  FontSizeLrFontSize600,
  FontSizeLrFontSize725,
  FontSizeLrFontSize875,
  FontWeightLrFontWeightLight,
  FontWeightLrFontWeightMedium,
  FontWeightLrFontWeightRegular,
  FontWeightLrFontWeightSemiBold,
  GradientLrGradientGold,
  GradientLrGradientOnboarding,
  GradientLrGradientOnboardingAlpha,
  GradientLrGradientPurple,
  GradientLrGradientSilver,
  GradientLrGradientTransparency,
  GradientLrplusColorBorderGradientAccent,
  LineHeightLrFontLineHeight1100,
  LineHeightLrFontLineHeight150,
  LineHeightLrFontLineHeight200,
  LineHeightLrFontLineHeight225,
  LineHeightLrFontLineHeight250,
  LineHeightLrFontLineHeight275,
  LineHeightLrFontLineHeight300,
  LineHeightLrFontLineHeight325,
  LineHeightLrFontLineHeight375,
  LineHeightLrFontLineHeight450,
  LineHeightLrFontLineHeight500,
  LineHeightLrFontLineHeight625,
  LineHeightLrFontLineHeight750,
  LineHeightLrFontLineHeight900,
  ProductCopyTextLamailleVersion,
  ShadowLrElevationMedium,
  ShadowLrElevationRaisedBottom,
  ShadowLrElevationRaisedTop,
  ShadowLrElevationStrong,
  ShadowLrElevationSubtle,
  SizeLrBreakpointLg,
  SizeLrBreakpointMd,
  SizeLrBreakpointSm,
  SizeLrBreakpointXl,
  SizeLrSizeDividerMd,
  SizeLrSizeDividerSm,
  SizeLrSizeFormInputMinWidthMd,
  SizeLrSizeFormInputMinWidthSm,
  SizeLrSizePopoverMaxHeight,
  SizeLrSizePopoverMaxWidth,
  SizeLrSizePopoverMinHeight,
  SizeLrSizePopoverMinWidth,
  SizeLrSizeSize0,
  SizeLrSizeSize025,
  SizeLrSizeSize050,
  SizeLrSizeSize075,
  SizeLrSizeSize100,
  SizeLrSizeSize1000,
  SizeLrSizeSize1100,
  SizeLrSizeSize1200,
  SizeLrSizeSize150,
  SizeLrSizeSize200,
  SizeLrSizeSize250,
  SizeLrSizeSize300,
  SizeLrSizeSize400,
  SizeLrSizeSize450,
  SizeLrSizeSize500,
  SizeLrSizeSize550,
  SizeLrSizeSize600,
  SizeLrSizeSize700,
  SizeLrSizeSize800,
  SizeLrSizeSize900,
  SizeLrSizeWebMaxWidth,
  SpaceLrSpacingSpacing0,
  SpaceLrSpacingSpacing025,
  SpaceLrSpacingSpacing050,
  SpaceLrSpacingSpacing075,
  SpaceLrSpacingSpacing100,
  SpaceLrSpacingSpacing1000,
  SpaceLrSpacingSpacing1100,
  SpaceLrSpacingSpacing125,
  SpaceLrSpacingSpacing150,
  SpaceLrSpacingSpacing200,
  SpaceLrSpacingSpacing225,
  SpaceLrSpacingSpacing250,
  SpaceLrSpacingSpacing300,
  SpaceLrSpacingSpacing400,
  SpaceLrSpacingSpacing500,
  SpaceLrSpacingSpacing550,
  SpaceLrSpacingSpacing600,
  SpaceLrSpacingSpacing700,
  SpaceLrSpacingSpacing800,
  SpaceLrSpacingSpacing900,
  SpaceLrSpacingSpacingActionIconTertiaryMd,
  SpaceLrSpacingSpacingActionIconTertiarySm,
  SpaceLrSpacingSpacingActionTertiaryMd,
  SpaceLrSpacingSpacingActionTertiarySm,
  StringLrFontCase,
  TypographyLegacyBodyLgReg,
  TypographyLegacyBodyLgRegUnder,
  TypographyLegacyBodyLgRegUpper,
  TypographyLegacyBodyLgSemi,
  TypographyLegacyBodyLgSemiUnder,
  TypographyLegacyBodyLgSemiUpper,
  TypographyLegacyBodyMdItalic,
  TypographyLegacyBodyMdReg,
  TypographyLegacyBodyMdRegUnder,
  TypographyLegacyBodyMdRegUpper,
  TypographyLegacyBodyMdSemi,
  TypographyLegacyBodyMdSemiUnder,
  TypographyLegacyBodyMdSemiUpperDesk,
  TypographyLegacyBodyMdSemiUpperMob,
  TypographyLegacyBodyMdSemiUpperTab,
  TypographyLegacyBodySmReg,
  TypographyLegacyBodySmRegStriked,
  TypographyLegacyBodySmRegUnder,
  TypographyLegacyBodySmSemi,
  TypographyLegacyBodySmSemiUnder,
  TypographyLegacyBodySmSemiUpper,
  TypographyLegacyBodyXsReg,
  TypographyLegacyBodyXsSemi,
  TypographyLegacyTitleLgDefault,
  TypographyLegacyTitleLgDeviceDesk,
  TypographyLegacyTitleLgDeviceMob,
  TypographyLegacyTitleLgDeviceTab,
  TypographyLegacyTitleMdDefault,
  TypographyLegacyTitleMdDeviceDesk,
  TypographyLegacyTitleMdDeviceMob,
  TypographyLegacyTitleMdDeviceTab,
  TypographyLegacyTitleSmDefault,
  TypographyLegacyTitleSmDeviceDesk,
  TypographyLegacyTitleSmDeviceMob,
  TypographyLegacyTitleSmDeviceTab,
  TypographyLegacyTitleXlDefault,
  TypographyLegacyTitleXlDeviceDesk,
  TypographyLegacyTitleXlDeviceMob,
  TypographyLegacyTitleXlDeviceTab,
  TypographyLegacyTitleXsDefault,
  TypographyLegacyTitleXsDeviceDesk,
  TypographyLegacyTitleXsDeviceMob,
  TypographyLegacyTitleXsDeviceTab,
  TypographyLegacyTitleXxsDefault,
  TypographyLegacyTitleXxsDeviceDesk,
  TypographyLegacyTitleXxsDeviceMob,
  TypographyLegacyTitleXxsDeviceTab,
  TypographyLrFontBodyBalancedLight,
  TypographyLrFontBodyBalancedMedium,
  TypographyLrFontBodySmallLight,
  TypographyLrFontBodySmallMedium,
  TypographyLrFontBodyStandardLight,
  TypographyLrFontBodyStandardMedium,
  TypographyLrFontBodyTinyLight,
  TypographyLrFontBodyTinyMedium,
  TypographyLrFontButtonMd,
  TypographyLrFontButtonSm,
  TypographyLrFontDiscountPercentageMd,
  TypographyLrFontDiscountPercentageSm,
  TypographyLrFontDiscountPercentageXs,
  TypographyLrFontDisplayEnormousLightDesk,
  TypographyLrFontDisplayEnormousLightMob,
  TypographyLrFontDisplayEnormousMediumDesk,
  TypographyLrFontDisplayEnormousMediumMob,
  TypographyLrFontDisplayMassiveLightDesk,
  TypographyLrFontDisplayMassiveLightMob,
  TypographyLrFontDisplayMassiveMediumDesk,
  TypographyLrFontDisplayMassiveMediumMob,
  TypographyLrFontDisplayOversizeLightDesk,
  TypographyLrFontDisplayOversizeLightMob,
  TypographyLrFontDisplayOversizeMediumDesk,
  TypographyLrFontDisplayOversizeMediumMob,
  TypographyLrFontLinkLg,
  TypographyLrFontLinkMd,
  TypographyLrFontLinkSm,
  TypographyLrFontLinkXs,
  TypographyLrFontSubtitleCompactLight,
  TypographyLrFontSubtitleCompactMedium,
  TypographyLrFontSubtitleExtraLargeLightDesk,
  TypographyLrFontSubtitleExtraLargeLightMob,
  TypographyLrFontSubtitleExtraLargeMediumDesk,
  TypographyLrFontSubtitleExtraLargeMediumMob,
  TypographyLrFontSubtitleLargeLightDesk,
  TypographyLrFontSubtitleLargeLightMob,
  TypographyLrFontSubtitleLargeMediumDesk,
  TypographyLrFontSubtitleLargeMediumMob,
  TypographyLrFontSubtitleTightLight,
  TypographyLrFontSubtitleTightMedium,
  TypographyLrFontTitleBigLightDesk,
  TypographyLrFontTitleBigLightMob,
  TypographyLrFontTitleBigMediumDesk,
  TypographyLrFontTitleBigMediumMob,
  TypographyLrFontTitleGiantLightDesk,
  TypographyLrFontTitleGiantLightMob,
  TypographyLrFontTitleGiantMediumDesk,
  TypographyLrFontTitleGiantMediumMob,
  TypographyLrFontTitleHugeLightDesk,
  TypographyLrFontTitleHugeLightMob,
  TypographyLrFontTitleHugeMediumDesk,
  TypographyLrFontTitleHugeMediumMob
};
